// extracted by mini-css-extract-plugin
export var completionBody = "_jr-2";
export var completionCard = "_jr-0";
export var completionFooter = "_jr-3";
export var completionTitle = "_jr-1";